import { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import { kebabCase } from 'lodash';
import { Row, Col, Button, Label, FormGroup, SheetBody, SheetFooter } from 'twyne-new.ui';

import history from 'utils/history';
import Input from 'components/form/Input';

const propTypes = {
  onSubmit: PropTypes.func,
  data: PropTypes.any
}

export default function NavigationForm({ onSubmit }) {
  const [slugTouch, setSlugTouch] = useState(false)
  const [slug, setSlug] = useState("")
  const [name, setName] = useState("")

  const handleValidSubmit = useCallback(model => {
    onSubmit(model)
  }, [onSubmit])

  const handleCancel = useCallback(() => {
    history.goBack()
  }, [])

  const handleNameChange = useCallback(event => {
    const { currentTarget: { value } } = event
    if (!slugTouch)
      setSlug(kebabCase(value))
    setName(value)
  }, [slugTouch])

  const handleSlugChange = useCallback(event => {
    const { currentTarget: { value } } = event
    if (value && value.length)
      setSlugTouch(true)
    else
      setSlugTouch(false)
  }, [])

  return <Formsy onValidSubmit={handleValidSubmit}>
    <SheetBody>
      <Row>
        <Col size="12">
          <FormGroup>
            <Label>Name</Label>
            <Input required name="name" value={name} onChange={handleNameChange} />
          </FormGroup>
        </Col>
        <Col size="12">
          <FormGroup>
            <Label>Slug</Label>
            <Input required name="slug" value={slug} onChange={handleSlugChange} />
          </FormGroup>
        </Col>
      </Row>
    </SheetBody>
    <SheetFooter>
      <Button onClick={handleCancel} variant='ghost'>Cancel</Button>
      <Button type="submit" color="accent">Save</Button>
    </SheetFooter>
  </Formsy>
}

NavigationForm.propTypes = propTypes;
NavigationForm.defaultProps = {};
